/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Sizes supported natively by HeroUI's Modal.Container */
export type HeroUIModalSize = "xs" | "sm" | "md" | "lg" | "full" | "cover";

/** Extended sizes — rendered via a Tailwind max-w-* className on Modal.Dialog */
export type CustomModalSize = "xl" | "2xl" | "3xl" | "4xl" | "5xl";

export type ModalSize = HeroUIModalSize | CustomModalSize;

interface AllCommonModalState {
    isOpen: boolean;
    componentName: string | null | undefined;
    data?: any;
    endPoint: string | null;
    modalSize?: ModalSize;
    modalPadding?: string;
    hideCloseButton?: boolean;
    scrollable?: boolean;
}

interface OpenModalPayload {
    componentName: string;
    data?: any;
    modalSize?: ModalSize;
    endPoint?: string | null;
    modalPadding?: string;
    hideCloseButton?: boolean;
    scrollable?: boolean;
}

const initialState: AllCommonModalState = {
    isOpen: false,
    componentName: null,
    data: null,
    endPoint: null,
    modalSize: 'xl',
    modalPadding: 'px-8 py-6.5',
    hideCloseButton: false,
    scrollable: true,
};

const allCommonModalSlice = createSlice({
    name: "allCommonModal",
    initialState,
    reducers: {
        openModal: (state, action: PayloadAction<OpenModalPayload>) => {
            state.isOpen = true;
            state.componentName = action.payload.componentName;
            state.data = action.payload.data;
            state.endPoint = action.payload.endPoint ?? null;
            state.modalSize = action.payload.modalSize;
            state.modalPadding = action.payload.modalPadding;
            state.hideCloseButton = action.payload.hideCloseButton;
            state.scrollable = action.payload.scrollable ?? true;
        },
        closeModal: (state) => {
            state.isOpen = false;
            state.componentName = null;
            state.data = null;
            state.endPoint = null;
        }
    }
});

export const { openModal, closeModal } = allCommonModalSlice.actions;
export default allCommonModalSlice.reducer;
